// Global maintenance flag — взводится из apiRequest при 503 maintenance_mode.
// App.tsx подписывается и переключает UI на MaintenancePage когда true.

type Listener = (enabled: boolean, message: string) => void;

let _enabled = false;
let _message = '';
const _listeners: Listener[] = [];

export const getMaintenance = () => ({ enabled: _enabled, message: _message });

export const setMaintenance = (enabled: boolean, message: string) => {
  if (_enabled === enabled && _message === message) return;
  _enabled = enabled;
  _message = message;
  _listeners.forEach((l) => l(enabled, message));
};

export const onMaintenanceChange = (cb: Listener) => {
  _listeners.push(cb);
  return () => {
    const i = _listeners.indexOf(cb);
    if (i >= 0) _listeners.splice(i, 1);
  };
};
